import React from 'react';
import { ZapIcon, TrendingUpIcon, ShieldCheckIcon, SearchIcon, CheckCircleIcon, ArrowRightIcon, CheckIcon, SparklesIcon, ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      <section id="home" className="relative min-h-screen pt-24 lg:pt-28 pb-16 lg:pb-24 overflow-hidden" style={{
      background: 'linear-gradient(145deg, #1E3A8A 0%, #1E40AF 40%, #2563EB 100%)'
    }} data-id="element-558">
        {/* Background decorative elements */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-559">
          {/* Large gradient orb */}
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl" style={{
          background: 'radial-gradient(circle, #60A5FA 0%, transparent 70%)'
        }} data-id="element-560" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl" style={{
          background: 'radial-gradient(circle, #3B82F6 0%, transparent 70%)'
        }} data-id="element-561" />
          {/* Dot pattern */}
          <div className="absolute inset-0 opacity-[0.04]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-562" />
          {/* Norden rocket — subtle background */}
          <div className="absolute bottom-0 right-0 opacity-[0.08]" data-id="element-563">
            <img src="https://cdn.magicpatterns.com/uploads/u5Q7Jx9cFVaD48nmqCDvz9/Norden_met_raket.png" alt="" className="w-64 lg:w-[360px] h-auto translate-x-8 translate-y-4" data-id="element-564" />
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-565">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center min-h-[70vh]" data-id="element-566">
            {/* Left column — Emotional copy */}
            <div className="space-y-8" data-id="element-567">
              {/* Floating USP badges */}
              <div className="flex flex-wrap gap-3 animate-fade-in-up" data-id="element-568">
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float" data-id="element-569">
                  <ZapIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-570" />
                  Binnen 2 weken live
                </span>
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float-delay-1" data-id="element-571">
                  <TrendingUpIcon className="w-3.5 h-3.5 text-green-400" data-id="element-572" />
                  Meer conversie
                </span>
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float-delay-2" data-id="element-573">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-blue-300" data-id="element-574" />
                  Volledig ontzorgd
                </span>
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float-slow" data-id="element-575">
                  <SearchIcon className="w-3.5 h-3.5 text-purple-300" data-id="element-576" />
                  SEO-proof
                </span>
              </div>

              {/* H1 */}
              <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] xl:text-6xl font-extrabold text-white leading-[1.1] animate-fade-in-up-delay-1" data-id="element-577">
                Websites voor financiële dienstverleners in Alkmaar & Amsterdam
              </h1>

              {/* Subtitle */}
              <p className="hidden lg:block text-lg lg:text-xl text-white/85 max-w-lg leading-relaxed animate-fade-in-up-delay-2" data-id="element-578">
                Stop met dure Google Ads en marketingbureaus die alleen
                rapporten sturen. Wij bouwen websites voor accountants en
                adviseurs (1-5 medewerkers) die zorgen voor een structurele
                stroom aan nieuwe klanten.
              </p>

              {/* Trust points */}
              <div className="space-y-3 animate-fade-in-up-delay-3" data-id="element-579">
                <div className="flex items-center gap-3" data-id="element-580">
                  <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-581" />
                  <span className="text-white font-medium" data-id="element-582">
                    Vaste prijs vooraf, geen verrassingen
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-583">
                  <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-584" />
                  <span className="text-white font-medium" data-id="element-585">
                    Lokaal aanspreekpunt in begrijpelijke taal
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-586">
                  <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-587" />
                  <span className="text-white font-medium" data-id="element-588">
                    Geen lock-in, jij bent 100% eigenaar
                  </span>
                </div>
              </div>

              {/* Social proof line */}
              <p className="text-white/50 text-sm animate-fade-in-up-delay-4" data-id="element-589">
                Gespecialiseerd in accountancy & financieel advies • SEO
                inbegrepen
              </p>
            </div>

            {/* Right column — Prijsscan CTA */}
            <div className="animate-fade-in-up-delay-3" data-id="element-590">
              <div className="bg-white rounded-2xl shadow-2xl p-7 lg:p-9 relative overflow-hidden" data-id="element-591">
                {/* Decorative gradient blob */}
                <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-30 blur-3xl pointer-events-none" style={{
                background: 'radial-gradient(circle, #DBEAFE 0%, transparent 70%)'
              }} data-id="element-592" />

                <div className="relative" data-id="element-593">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-2xl bg-accent-light flex items-center justify-center mb-5 mt-2" data-id="element-594">
                    <SparklesIcon className="w-7 h-7 text-accent" data-id="element-595" />
                  </div>

                  {/* Heading */}
                  <h2 className="text-2xl lg:text-3xl font-extrabold text-navy-900 mb-2 leading-tight" data-id="element-596">
                    Wat kost jouw nieuwe website?
                  </h2>
                  <p className="text-sm lg:text-base text-slate-600 mb-6 leading-relaxed" data-id="element-597">
                    Doe de gratis prijsscan en ontvang binnen 2 minuten een
                    persoonlijke prijsindicatie op maat van jouw bedrijf.
                  </p>

                  {/* Benefits */}
                  <ul className="space-y-3 mb-7" data-id="element-598">
                    <li className="flex items-start gap-3" data-id="element-599">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-600">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-601" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-602">
                        Direct inzicht in de kosten
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-603">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-604">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-605" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-606">
                        Volledig op maat voor jouw bedrijf
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-607">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-608">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-609" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-610">
                        Klaar in minder dan 2 minuten
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-611">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-612">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-613" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-614">
                        Geen verplichtingen achteraf
                      </span>
                    </li>
                  </ul>

                  {/* Primary CTA */}
                  <a href="https://scan.noorddigital.nl/prijsscan" target="_blank" rel="noopener noreferrer" className="w-full bg-accent hover:bg-accent-hover text-white font-bold py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base flex items-center justify-center gap-2 animate-pulse-glow group" data-id="element-615">
                    Start gratis prijsscan
                    <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-616" />
                  </a>

                  {/* Trust signals */}
                  <div className="flex items-center justify-center gap-4 mt-5 text-xs text-slate-400" data-id="element-617">
                    <span className="flex items-center gap-1" data-id="element-618">
                      <ClockIcon className="w-3.5 h-3.5 text-accent" data-id="element-619" />
                      &lt; 2 min
                    </span>
                    <span className="flex items-center gap-1" data-id="element-620">
                      <CheckCircleIcon className="w-3.5 h-3.5 text-green-500" data-id="element-621" />
                      100% gratis
                    </span>
                    <span className="flex items-center gap-1" data-id="element-622">
                      <ShieldCheckIcon className="w-3.5 h-3.5 text-green-500" data-id="element-623" />
                      Geen spam
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust badges strip below hero */}
      <div className="relative bg-white border-b border-navy-100" data-id="element-624">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5" data-id="element-625">
          <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-12" data-id="element-626">
            <span className="flex items-center gap-2 text-sm font-medium text-navy-700" data-id="element-627">
              <CheckIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-628" />
              WordPress specialist
            </span>
            <span className="flex items-center gap-2 text-sm font-medium text-navy-700" data-id="element-629">
              <CheckIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-630" />
              SEO geoptimaliseerd
            </span>
            <span className="flex items-center gap-2 text-sm font-medium text-navy-700" data-id="element-631">
              <CheckIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-632" />
              Snelle oplevering
            </span>
          </div>
        </div>
      </div>
    </>;
}